/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetPLForSelfByAccountStatus200,
  GetPLForSelfByAccountStatus401,
  GetPLForSelfByAccountStatus404,
  GetPLForSelfByAccountStatus500,
} from '../types/GetPLForSelfByAccount'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getPLForSelfByAccount } from '../clients/getPLForSelfByAccount'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getPLForSelfByAccountQueryKey = () => [{ url: '/v1/pl/self' }] as const

type GetPLForSelfByAccountQueryKey = ReturnType<typeof getPLForSelfByAccountQueryKey>

export function getPLForSelfByAccountQueryOptions(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getPLForSelfByAccountQueryKey()
  return queryOptions<
    GetPLForSelfByAccountStatus200,
    ResponseErrorConfig<
      | GetPLForSelfByAccountStatus401
      | GetPLForSelfByAccountStatus404
      | GetPLForSelfByAccountStatus500
    >,
    GetPLForSelfByAccountStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getPLForSelfByAccount({
        ...config,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get account-by-account PL breakdown for the logged in user
 * {@link /v1/pl/self}
 */
export function useGetPLForSelfByAccount<
  TData = GetPLForSelfByAccountStatus200,
  TQueryData = GetPLForSelfByAccountStatus200,
  TQueryKey extends QueryKey = GetPLForSelfByAccountQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetPLForSelfByAccountStatus200,
        ResponseErrorConfig<
          | GetPLForSelfByAccountStatus401
          | GetPLForSelfByAccountStatus404
          | GetPLForSelfByAccountStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? getPLForSelfByAccountQueryKey()

  const queryResult = useQuery(
    {
      ...getPLForSelfByAccountQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetPLForSelfByAccountStatus401
      | GetPLForSelfByAccountStatus404
      | GetPLForSelfByAccountStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
